import QRCode from 'react-qr-code'
import { useTranslation } from '../../hooks/useTranslation'
import Money from '../../design/Money'
import Moment, { MomentHeadline, MomentText } from './Moment'
import ScanFrame from './ScanFrame'

/**
 * Pay, or take the receipt: the amount first and largest, then the code, big
 * enough to scan from arm's length, stacked to fit the order side. MobilePay sends the QR as an image; the receipt is a link we
 * draw ourselves.
 */
export default function PaymentMoment({
  kind,
  url,
  amount,
  currency,
}: {
  kind: 'mobilepay' | 'receipt'
  url: string
  amount: number
  currency: string
}) {
  const { t } = useTranslation()
  // Literal keys, so the translation coverage test can find them.
  const headline = kind === 'mobilepay' ? 'mobilepay-scan-to-pay' : 'receipt-scan-to-download'
  const text = kind === 'mobilepay' ? 'mobilepay-scan-to-pay-sub' : 'receipt-scan-to-download-sub'

  return (
    <Moment>
      <div className="flex w-full flex-col items-center space-y-cfd-3">
        <div className="flex flex-col items-center">
          <div className="whitespace-nowrap font-volte-semibold text-cfd-total tabular-nums text-primary">
            <Money amount={amount} currency={currency} lead />
          </div>
          <MomentHeadline className="mt-cfd-1">{t(headline)}</MomentHeadline>
          <MomentText>{t(text)}</MomentText>
        </div>

        <ScanFrame>
          <div
            data-testid="payment-qr-container"
            className="h-[clamp(150px,min(42vh,30vw),460px)] w-[clamp(150px,min(42vh,30vw),460px)] portrait:h-[clamp(150px,22vh,380px)] portrait:w-[clamp(150px,22vh,380px)] rounded-[clamp(10px,1.6vh,18px)] bg-white p-cfd-2 shadow-[0_18px_60px_rgba(39,42,48,0.16)]"
          >
            {kind === 'mobilepay' ? (
              <img src={url} alt={t(headline)} className="h-full w-full object-contain" />
            ) : (
              <QRCode value={url} style={{ height: '100%', width: '100%' }} />
            )}
          </div>
        </ScanFrame>
      </div>
    </Moment>
  )
}
